import React, { Component } from 'react';
import DialogBase from '.';
import Button from '../Button';
import { withInjectedProps } from '../InjectedPropsContext';

/**
 * A dialog that shows a message, and is intended to be used with a <Button/>
 * to easily present a message when a button is clicked.
 */

class MessageDialogBase extends Component {
  static idCounter = 0;

  constructor(props) {
    super(props);
    this.state = {
      dialogVisible: false,
      messageDialogId: MessageDialog.idCounter++
    };
  }

  eventInterceptedChildren() {
    const child = React.Children.only(this.props.children);
    let { onClick } = child.props;
    const props = {};
    // Intercept events, and attach dialog open
    switch (child.type) {
      case Button:
        props.onClick = evt => {
          this.setState({ dialogVisible: true });
          if (onClick) onClick(evt);
        };
        break;
      default:
        throw new Error(`<MessageDialog> does not support type '${child.type}'.`);
    }
    return React.cloneElement(child, props);
  }

  render() {
    const { messageDialogId } = this.state;
    const {
      name = `messageDialog_${messageDialogId}`,
      messageTitle = 'Message',
      messageText = 'Message Text',
      messageButtonText = 'OK',
      messageDialogWidth = '400px',
      alwaysEnabled
    } = this.props;
    return (
      <>
        <DialogBase
          name={name}
          title={messageTitle}
          buttons={[
            <Button
              key="0"
              name={`${name}.buttonOk`}
              alwaysEnabled={alwaysEnabled}
              onClick={() => this.setState({ dialogVisible: false })}
            >
              {messageButtonText}
            </Button>
          ]}
          alwaysEnabled={alwaysEnabled}
          visible={this.state.dialogVisible}
          onClose={() => this.setState({ dialogVisible: false })}
          width={messageDialogWidth}
        >
          {messageText}
        </DialogBase>
        {this.eventInterceptedChildren()}
      </>
    );
  }
}

const MessageDialog = withInjectedProps(MessageDialogBase);

export { MessageDialog };
export default MessageDialog;
